export default {
  payment_methods: []
}
